import { handleError } from '../request';

const ErrorMessage = error => (
  <h2>An error occurred: {handleError(error)}</h2>
);

export default ErrorMessage;
